import { ContractualMonth } from "@shared/models";

export const CONTRACTUAL_MONTHS: ContractualMonth[] = [
  {
    monthLong: "January",
    monthShort: "JAN",
    start: { month: "01", day: "01", fosStart: "01JAN" },
    end: { month: "01", day: "30", fosEnd: "30JAN" },
    asInt: "01",
  },
  {
    monthLong: "February",
    monthShort: "FEB",
    start: { month: "01", day: "31", fosStart: "31JAN" },
    end: { month: "03", day: "01", fosEnd: "01MAR" },
    asInt: "02",
  },
  {
    monthLong: "March",
    monthShort: "MAR",
    start: { month: "03", day: "02", fosStart: "02MAR" },
    end: { month: "03", day: "31", fosEnd: "31MAR" },
    asInt: "03",
  },
  {
    monthLong: "April",
    monthShort: "APR",
    start: { month: "04", day: "01", fosStart: "01APR" },
    end: { month: "05", day: "01", fosEnd: "01MAY" },
    asInt: "04",
  },
  {
    monthLong: "May",
    monthShort: "MAY",
    start: { month: "05", day: "02", fosStart: "02MAY" },
    end: { month: "06", day: "01", fosEnd: "01JUN" },
    asInt: "05",
  },
  {
    monthLong: "June",
    monthShort: "JUN",
    start: { month: "06", day: "02", fosStart: "02JUN" },
    end: { month: "07", day: "01", fosEnd: "01JUL" },
    asInt: "06",
  },
  {
    monthLong: "July",
    monthShort: "JUL",
    start: { month: "07", day: "02", fosStart: "02JUL" },
    end: { month: "07", day: "31", fosEnd: "31JUL" },
    asInt: "07",
  },
  {
    monthLong: "August",
    monthShort: "AUG",
    start: { month: "08", day: "01", fosStart: "01AUG" },
    end: { month: "08", day: "30", fosEnd: "30AUG" },
    asInt: "08",
  },
  {
    monthLong: "September",
    monthShort: "SEP",
    start: { month: "08", day: "31", fosStart: "31AUG" },
    end: { month: "09", day: "30", fosEnd: "30SEP" },
    asInt: "09",
  },
  {
    monthLong: "October",
    monthShort: "OCT",
    start: { month: "10", day: "01", fosStart: "01OCT" },
    end: { month: "10", day: "31", fosEnd: "31OCT" },
    asInt: "10",
  },
  {
    monthLong: "November",
    monthShort: "NOV",
    start: { month: "11", day: "01", fosStart: "01NOV" },
    end: { month: "12", day: "01", fosEnd: "01DEC" },
    asInt: "11",
  },
  {
    monthLong: "December",
    monthShort: "DEC",
    start: { month: "12", day: "02", fosStart: "02DEC" },
    end: { month: "12", day: "31", fosEnd: "31DEC" },
    asInt: "12",
  },
];
